module.exports = __webpack_public_path__ + "app/assets/images/woman14-7cea4732070bcf38bb721ac99d01e5ac.jpg";